import React, { useEffect, useState } from "react";
import { stripeSubscriptionStatus } from "../../assets/Js/stripeSubscriptionStatus";

export const Badge = ({ status, text }) => {
  const [color, setColor] = useState();

  useEffect(() => {
    setColor(whichColor());
  }, []);

  const whichColor = () => {
    switch (status) {
      case stripeSubscriptionStatus.active:
        return "badge-success";
      case stripeSubscriptionStatus.incomplete:
        return "badge-incomplete";
      case stripeSubscriptionStatus.incomplete_expired:
        return "badge-expired";
      case stripeSubscriptionStatus.canceled:
      case stripeSubscriptionStatus.trialing:
      case stripeSubscriptionStatus.past_due:
      case stripeSubscriptionStatus.unpaid:
        return "badge-warning";
    }
  };

  return <span className={`badge ${color} p-1`}>{text}</span>;
};
